export const getWorker = ({ worker }) => worker.worker;

export const getWorkers = ({ worker }) => worker.workers;

export const getWorkerEmailHistory = ({ worker }) => worker.emailHistory;
